import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  LeasedOptionWrapper,
  LeasedOption
} from '../ItemCreationForm/SelectLeasedTypeStep/styled';
import {
  ItemCreationContentContainer,
  ItemCreationContentTitle,
  ItemCreationLayoutWrapper
} from '../ItemCreationForm/ItemCreationLayout/styled';
import { StepModalOptionText } from '../ItemCreationForm/styled';
import PassIcon from '../../public/static/images/new_ad/icons/icon-pass.svg';
import CalendarIcon from '../../public/static/images/new_ad/icons/icon-calendar.svg';
import { Icon } from '../Icon';
import { ItemCreationHeader } from '../../styled/placeholders.styled';

export const ItemCreationSkeleton = () => {
  const { t } = useTranslation();

  const leasedConfig = [
    {
      icon: PassIcon,
      text: t('new_ad.sell_estate')
    },
    {
      icon: CalendarIcon,
      text: t('new_ad.rent_estate')
    }
  ];

  return (
    <>
      <ItemCreationHeader>{t('new_ad.title')}</ItemCreationHeader>
      <ItemCreationLayoutWrapper>
        <ItemCreationContentContainer>
          <ItemCreationContentTitle tag="h2_new">
            {t('new_ad.title')}
          </ItemCreationContentTitle>
          <LeasedOptionWrapper>
            {leasedConfig.map(leasedType => (
              <LeasedOption key={leasedType.text} $isDefaultStyles>
                <Icon
                  IconComponent={leasedType.icon}
                  width={48}
                  height={48}
                  indent={false}
                />
                <StepModalOptionText tag="body_3">
                  {leasedType.text}
                </StepModalOptionText>
              </LeasedOption>
            ))}
          </LeasedOptionWrapper>
        </ItemCreationContentContainer>
      </ItemCreationLayoutWrapper>
    </>
  );
};
